import {
  getEnv
} from 'src/Utility/utility';

// on choose fibre plan page load.
export const tagOnChooseFibrePlan = (appProactiveFlag, miniAppProactiveSalesFlag, serviceProviders, redirect = false) => {

  window.MyTIQ.view({
    service_application_step: 'myvodacom: fibre: fibre available: choose a fibre plan',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    page_name: `myvodacom: fibre: fibre is available: choose a fibre plan${ redirect ? ': prepaid redirect' : '' }`,
    fibre_proactive_sales_type: [ appProactiveFlag ],
    mini_app_header: [ miniAppProactiveSalesFlag ],
    service_provider: [ serviceProviders ]
  });
};

//on choose fibre page call me back button
export const tagOnHelpMeChooseCallMeBackButtonClick = () => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: 'myvodacom: fibre: fibre is available: choose a fibre plan: call me back',
    link_url: `https://www${ getEnv() }.vodacom.co.za/cloud/fibre/sales/choosePlan`
  });
};

//on choose plan top-pick click
export const tagOnTopPickClick = (download, upload, productPrice) => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: `myvodacom: fibre: fibre is available: choose a fibre plan: top picks: ${ download } download + ${ upload } upload`,
    sales_product_id: `${ download } download + ${ upload } upload`,
    sales_product_price: [ productPrice ],
    link_url: `https://www${ getEnv() }.vodacom.co.za/cloud/fibre/sales/planDetails`
  });
};

export const tagOnPrepaidCardClick = () => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: 'myvodacom: fibre: fibre is available: choose a fibre plan: prepaid',
    page_event: 'See available offers',
    link_url: `https://www${ getEnv() }.vodacom.co.za/cloud/fibre/prepaid`
  });
};

export const tagOnSwitchToBusinessClick = () => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: 'myvodacom: fibre: fibre is available: choose a fibre plan: switch to business',
    page_event: 'switch to business clicked',
    link_url: `https://www${ getEnv() }.vodacombusiness.co.za/business/fibre/sales/lead`
  });
};

export const tagBreadCrumbClick = (tag, link, isAvailable) => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'e',
    link_name: `myvodacom: fibre: ${ isAvailable ? 'fibre is available' : 'fibre is not available' }: choose a fibre plan: ${ tag }`,
    page_event: `fibre:breadcrumb:${ tag } clicked`,
    link_url: [ link ]
  });
};

export const tagContractTermFilterClick = (option) => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: `myvodacom: fibre: fibre is available: choose a fibre plan: contract length filter: ${ option }`,
    filter_query_web: [ option ],
    tool: 'myvodacom: fibre: fibre is available: choose a fibre plan: contract length filter',
    link_url: `https://www${ getEnv() }.vodacom.co.za/cloud/fibre/sales/choosePlan`
  });
};

export const tagSpeedFilterClick = (option) => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: `myvodacom: fibre: fibre is available: choose a fibre plan: download speed filter: ${ option }`,
    filter_query_web: [ option ],
    tool: 'myvodacom: fibre: fibre is available: choose a fibre plan: download speed filter',
    link_url: `https://www${ getEnv() }.vodacom.co.za/cloud/fibre/sales/choosePlan`

  });
};

export const tagPromotionsOnlyFilterClick = (option) => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: `myvodacom: fibre: fibre is available: choose a fibre plan: promotions filter: ${ option }`,
    filter_query_web: [ option ],
    tool: 'myvodacom: fibre: fibre is available: choose a fibre plan: promotions filter',
    link_url: `https://www${ getEnv() }.vodacom.co.za/cloud/fibre/sales/choosePlan`

  });
};

export const tagClearAllFilterClick = (option, all) => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: `myvodacom: fibre: fibre is available: choose a fibre plan: clear filter : ${ all ? 'clear all' : option }`,
    filter_query_web: [ option ],
    tool: `myvodacom: fibre: fibre is available: choose a fibre plan: clear filter : ${ all ? 'clear all' : option }`,
    link_url: `https://www${ getEnv() }.vodacom.co.za/cloud/fibre/sales/choosePlan`
  });
};

export const tagPriceSortFilterClick = (option) => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: `myvodacom: fibre: fibre is available: choose a fibre plan: sort by:${ option }`,
    filter_query_web: [ option ],
    tool: `myvodacom: fibre: fibre is available: choose a fibre plan: sort by:${ option }`,
    link_url: `https://www${ getEnv() }.vodacom.co.za/cloud/fibre/sales/choosePlan`
  });
};

export const tagOnNoPackagesAvailableForProvider = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_event: 'view',
    page_name: 'myvodacom: fibre: check coverage: fibre is not available',
    service_application_event: 'start,finish',
    service_application_name: 'myvodacom: fibre: check coverage: fibre is not available (query)',
    service_application_step: 'myvodacom: fibre: check coverage: fibre is not available',
    service_application_type: 'query'
  });
};

export const tagOnPlanDetailsContractDurationClick = (option) => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: `myvodacom: fibre: check coverage: plan details: contract duration:${ option }`,
    filter_query_web: [ option ],
    tool: `myvodacom: fibre: check coverage: plan details: contract duration:${ option }`,
    link_url: `https://www${ getEnv() }.vodacom.co.za/cloud/fibre/sales/planDetails`

  });
};

export const tagOnPlanDetailsProviderClick = (provider) => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: `myvodacom: fibre: check coverage: plan details: service provider:${ provider }`,
    filter_query_web: [ provider ],
    tool: `myvodacom: fibre: check coverage: plan details: service provider:${ provider }`,
    link_url: `https://www${ getEnv() }.vodacom.co.za/cloud/fibre/sales/planDetails`
  });
};

// on help me choose plan page load.
export const tagOnHelpMeChoosePlan = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_event: 'use',
    page_tool_name: 'myvodacom: fibre: check coverage: help me choose plan'
  });
};

// on help me choose how do you use.
export const tagOnHowDoYouUse = () => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: 'myvodacom: fibre: fibre is available: help me choose: how do you use',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: fibre is available: how do you use'
  });
};

// on help me choose how many people use.
export const tagOnHelpMeChooseHowMay = () => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: 'myvodacom: fibre: fibre is available: help me choose: how many',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: fibre is available: how many people'
  });
};

// on Contact information page load.
export const tagOnContactInformationPageLoad = () => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: 'myvodacom: fibre: fibre is available: new customer: lead form',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: fibre is available: new customer: lead form',
    fibre_sales_customer_type : 'existing'
  });
};

// Tag when user start filling the contact information page
export const tagOnContactInformationDetailsStarted = () => {
  window.MyTIQ && window.MyTIQ.view({
    page_form_name: 'myvodacom: fibre: fibre is available: personal details for new customer',
    page_form_event: 'started',
    fibre_sales_customer_type : 'existing'
  });
};

// on finalize error retry attempt error.
export const tagOnFinalizeOrderError = errorMsg => {
  window.MyTIQ && window.MyTIQ.view({
    page_form_event: 'error',
    page_errors: [ errorMsg ],
    page_name: 'myvodacom: fibre: check coverage: finalise order form error',
    fibre_sales_customer_type : 'existing'
  });
};

// on finalize error final error after 3 retry attempts
export const tagOnFinalizeOrderErrorPage = errorMsg => {
  window.MyTIQ && window.MyTIQ.view({
    page_form_event: 'error',
    page_errors: [ errorMsg ],
    page_name: 'myvodacom: fibre: check coverage: finalise order form error',
    fibre_sales_customer_type : 'existing'
  });
};

// TODO: on help me choose how do you use.
export const tagOnCheckCoverageNoMatch = () => {
  window.MyTIQ && window.MyTIQ.view({
    page_event: 'view',
    page_name: 'myvodacom: fibre: check coverage: filter by: no match for this criteria'
  });
};

// TODO: on help me choose how do you use.
export const tagOnAdditionalService = (productId, productQuntity, productPrice) => {
  window.MyTIQ && window.MyTIQ.link({
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    sales_event: 'cart_add',
    service_application_step: 'myvodacom: fibre: check coverage: plan details: choose additional service',
    service_application_type: 'transaction',
    sales_product_category: [ 'Fibre' ],
    sales_product_id: [ productId ],
    sales_product_quantity: `${ [ productQuntity ] }`,
    sales_product_price: [ productPrice ]
  });
};

export const tagOnRemoveAdditionalService = (productId, productQuntity, productPrice) => {
  window.MyTIQ && window.MyTIQ.link({
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    sales_event: 'cart_remove',
    service_application_step: 'myvodacom: fibre: check coverage: plan details: choose additional service',
    service_application_type: 'transaction',
    sales_product_category: [ 'Fibre' ],
    sales_product_id: [ productId ],
    sales_product_quantity: `${ [ productQuntity ] }`,
    sales_product_price: [ productPrice ]
  });
};

// TODO: on suggesting user a plan with the help of help me choose plan tool.
export const tagOnBestSuitedForYou = () => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: 'myvodacom: fibre: fibre is available:  best suited for you',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: fibre is available: best suited for you'
  });
};

// on successful submitting sales lead request
export const tagOnRequestSubmitSuccess = (refNumber, page, taggingIdArray, taggingQtyArray, taggingPriceArray, isUserExisting, contactNo) => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_event: 'finish',
    service_application_step: 'myvodacom: fibre: fibre available: success',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    page_name: `myvodacom: fibre: check coverage: fibre available: ${ page }`,
    page_form_name: isUserExisting ? 'myvodacom: fibre: fibre is available: personal details for xds' : 'myvodacom: fibre: fibre is available: personal details for new customer',
    page_form_event: 'success',
    sales_event: isUserExisting ? 'fibre_available, purchase' : 'fibre_available',
    sales_order_id: `${ [ refNumber ] }`,
    sales_product_category: [ 'Fibre' ],
    sales_product_id: taggingIdArray,
    sales_product_quantity: taggingQtyArray,
    sales_product_price: taggingPriceArray,
    visitor_customer_id: (contactNo ? [ window.sha256(contactNo) ]: ''),
    fibre_sales_customer_type : 'existing'
  });
};

// call these tags on various events in filter page
export const tagOnFilterDownloadSpeed = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_event: 'use',
    page_tool_name: 'myvodacom: fibre: check coverage: filter by: download speed'
  });
};

export const tagOnFilterSortBy = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_event: 'use',
    page_tool_name: 'myvodacom: fibre: check coverage: filter by: sort'
  });
};

// call this when fibre plan details page is loaded.
export const tagOnFibrePlanDetailsPageLoad = () => {

  window.MyTIQ && window.MyTIQ.view({
    service_application_step: 'myvodacom: fibre: check coverage: plan details',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: check coverage: plan details'
  });
};

// call this when user is done on selection options on plan details page.
export const tagOnFibrePlanDetails = (productId, productQty, productPrice, isRecommended) => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: 'myvodacom: fibre: check coverage: plan details',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: check coverage: plan details',
    sales_event: 'view',
    sales_product_category: isRecommended ? 'Fibre - Recommended deals' : 'Fibre - Standard deals',
    sales_product_id: [ productId ],
    sales_product_quantity: [ productQty ],
    sales_product_price: [ productPrice ]
  });
};

// call this when fibre plan details contract duration is selected
export const tagOnFibrePlanDetailsContractDuration = () => {
  window.MyTIQ && window.MyTIQ.link({
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    service_application_step: 'myvodacom: fibre: check coverage: plan details: contract duration'
  });
};

// call this when checkout is clicked on fibre plan details
export const tagOnFibrePlanDetailsContinueToCheckout = (productId, productQty, productPrice) => {
  let selectedProducts = [];
  selectedProducts = [ productId, productQty, productPrice ];
  window.MyTIQ && window.MyTIQ.link({
    sales_event: 'order_checkout',
    sales_product_category: [ 'Fibre' ],
    sales_product_id: productId,
    sales_product_quantity: productQty,
    sales_product_price: productPrice
  });
};

// call this when deliver address selection page is loaded.
export const tagOnDeliveryPageLoad = (contractDuration) => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: 'myvodacom: fibre: fibre is available: confirm delivery address: where to deliver',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: fibre is available: confirm delivery address: where to deliver',
    contract_duration: contractDuration
  });
};

// call this when Employeee details selection page is loaded.
export const tagOnEmployerDetailsPageLoad = () => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: 'myvodacom: fibre: fibre is available: exisiting customer: employment details',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: fibre is available: exisiting customer: employment details',
    fibre_sales_customer_type : 'existing'
  });
};

// Call When user start filling the user details form
export const tagOnPersonalDetailsInteraction = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_form_name: 'myvodacom: fibre: fibre is available: personal details for xds',
    page_form_event: 'started'
  });
};

// call this when otp screen get loaded.
export const tagOnOtpScreenLoad = (contactNo) => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: 'myvodacom: fibre: fibre is available: exisiting customer: enter otp',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: fibre is available: exisiting customer: enter otp',
    visitor_customer_id: contactNo ? [ window.sha256(contactNo) ] : null,
    fibre_sales_customer_type : 'existing'
  });
};

// Call When user start filling otp
export const tagOnUserEnterOtp = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_form_name: 'myvodacom: fibre: fibre is available: personal details for xds',
    page_form_event: 'started',
    fibre_sales_customer_type : 'existing'
  });
};

// call this when Quotation get loaded.
export const tagOnQuotationPageLoad = () => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: 'myvodacom: fibre: fibre is available: finalise order',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: check coverage (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: fibre is available: finalise order lead form',
    fibre_sales_customer_type : 'existing'
  });
};

// Call When user select terms & condition checkbox
export const tagOnTermsAndConditionCheckboxSelect = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_name: 'myvodacom: fibre: fibre is available: finalise order: accept quotation',
    page_form_event: 'use',
    fibre_sales_customer_type : 'existing'
  });
};

// Call when user is blocked OR OTP error
export const tagOnOtpError = (errorMsg) => {
  window.MyTIQ && window.MyTIQ.view({
    page_form_event: 'error',
    page_errors: [ errorMsg ],
    page_name: 'myvodacom: fibre: fibre is available: existing customer otp error',
    fibre_sales_customer_type : 'existing'
  });
};

// Call when lead submission get failed
export const tagOnLeadSubmissionFail = (errorMsg) => {
  window.MyTIQ && window.MyTIQ.view({
    page_form_event: 'error',
    page_errors: [ errorMsg ],
    page_name: 'myvodacom: fibre: check coverage: finalise order form error',
    fibre_sales_customer_type : 'existing'
  });
};

export const tagOnPackageTypeFilterSelection = (filterType) => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_name: `myvodacom: fibre: check coverage: choose a fibre plan filter: ${ filterType }`,
    page_tool_event: 'use'
  });
};

export const tagOnDebiCheckExistingCustomer = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_name: 'myvodacom: fibre: fibre is available: existing customer: credit vetting: debi check',
    page_tool_event: 'use',
    fibre_sales_customer_type: 'new'
  });
};

export const tagOnCallMeBackBtnClicked = (pageName) => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_event: 'use',
    page_tool_name: `myvodacom: fibre: ${ pageName } : call me back`
  });
};

export const tagOnCallMeBackFormInteraction = (msg) => {
  window.MyTIQ && window.MyTIQ.link({
    page_form_name: `myvodacom: fibre: ${ msg } : call me back form`,
    page_form_event: 'started'
  });
};

export const tagOnCallMeBackSuccess = (msisdn, referenceNo) => {
  window.MyTIQ && window.MyTIQ.link({
    page_form_name: 'myvodacom: fibre: new customer vetting: call me back form',
    page_form_event: 'success',
    visitor_customer_id: msisdn ? window.sha256(msisdn): '',
    sales_event:'fibre_callmeback',
    sales_order_id: referenceNo
  });
};

export const tagOnCallMeBackSuccessPopup = (msisdn, referenceNo) => {
  window.MyTIQ && window.MyTIQ.link({
    service_application_event: 'finish',
    service_application_step: 'myvodacom: fibre: fibre is available: call me back: success',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: fibre is available: call me back (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: fibre is available: call me back: success',
    page_form_name: 'myvodacom: fibre: fibre is available: call me back form',
    page_form_event: 'success',
    visitor_customer_id: msisdn ? window.sha256(msisdn) : '',
    sales_event:'fibre_callmeback',
    sales_order_id: referenceNo
  });
};

export const tagOnCallMeBackFail = (msg) => {
  window.MyTIQ && window.MyTIQ.link({
    page_form_event: 'error',
    page_errors: 'We were unable to submit your request. Please try again later.',
    page_name: `myvodacom: fibre: ${ msg } : call me back: journey error`
  });
};

export const tagOnCallMeBackPopupLoad = () => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_event: 'start',
    service_application_step: 'myvodacom: fibre: fibre is available: call me back',
    page_event: 'view',
    service_application_name: 'myvodacom: fibre: fibre is available: call me back (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: fibre is available: call me back'
  });
};

export const tagOnWhatsappButtonClick = () => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: 'myvodacom: fibre: fibre is available: call me back: callBack WhatsApp',
    link_url: 'https://api.whatsapp.com/send/?phone=27826223509',
    page_tool_name: 'WhatsApp'
  });
};

export const tagOnPortalLoginLoad = () => {
  window.MyTIQ && window.MyTIQ.view({
    page_event: 'view',
    service_application_event: 'start',
    service_application_step: 'myvodacom: fibre: partner',
    service_application_name: 'myvodacom: fibre: partner (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: partner'
  });
};

export const tagOnPortalLoginButtonClick = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_name: 'myvodacom: fibre: partner: login',
    page_tool_event: 'use'
  });
};

export const tagOnPortalLoginOtpLoad = () => {
  window.MyTIQ && window.MyTIQ.view({
    page_event: 'view',
    service_application_event: 'start',
    service_application_step: 'myvodacom: fibre: partner: enter otp',
    service_application_name: 'myvodacom: fibre: partner (transaction)',
    service_application_type: 'transaction',
    page_name: 'myvodacom: fibre: partner: enter otp'
  });
};

export const tagOnPortalLoginSubmitOtpButtonClick = () => {
  window.MyTIQ && window.MyTIQ.link({
    link_type: 'o',
    link_name: 'myvodacom: fibre: partner: enter otp: submit otp',
    link_url: 'https://www.vodacom.co.za/vodacom/fibre/sales/leads'
  });
};

export const tagOnPortalLoginResendOtpButtonClick = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_form_name: 'myvodacom: fibre: partner: enter otp: resend otp',
    page_tool_event: 'use'
  });
};

export const tagOnPortalLoginDismissButtonClick = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_form_name: 'myvodacom: fibre: partner: enter otp: dismiss error',
    page_tool_event: 'use'
  });
};

export const tagOnPortalLoginOtpFail = (error) => {
  window.MyTIQ && window.MyTIQ.link({
    page_form_event: 'error',
    page_errors: error,
    page_name: 'myvodacom: fibre: partner: enter otp'
  });
};

export const tagOnPortalLoginOtpBlockedLoad = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_form_event: 'error',
    page_errors: 'You\'ve entered 3 invalid OTPs',
    page_name: 'myvodacom: fibre: partner: otp: blocked: temporarily'
  });
};